// Unified apps/catalog config for Navbar and Home Arcade
export interface GameApp {
  id: string;
  title: string;
  subtitle?: string; // short, engaging one‑liner
  path: string;
  image?: string;
  banner?: string;
  category: "play" | "earn" | "guts" | "create" | "buy";
  isLocked?: boolean;
  apy?: string; // for earn items only
}

// Static catalog (does not include live APY)
const STATIC_APPS: Omit<GameApp, "apy">[] = [
  // Play
  // Hidden until actively developed:
  // {
  //   id: "jackpot",
  //   title: "JACKPOT",
  //   path: "#",
  //   category: "play",
  //   image: "/lobby/jackpot.svg",
  //   isLocked: true,
  //   banner: "/lobby/banners/jackpot.svg",
  // },
  // {
  //   id: "henlochain",
  //   title: "HENLOCHAIN",
  //   path: "#",
  //   category: "play",
  //   image: "/lobby/henlochain.svg",
  //   isLocked: true,
  //   banner: "/lobby/banners/henlochain.svg",
  // },
  // {
  //   id: "tetris",
  //   title: "BRICK BY BRICK",
  //   subtitle: "stack til u drop",
  //   path: "/tetris",
  //   category: "play",
  //   image: "/lobby/brickbybrick.svg",
  //   isLocked: false,
  //   banner: "/lobby/banners/tetris.svg",
  // },

  // Buy
  {
    id: "buy",
    title: "BUY $HENLO",
    subtitle: "",
    path: "/buy",
    category: "buy",
  },

  // Guts
  {
    id: "wall",
    title: "WALL",
    subtitle: "stack bricks. get rich",
    path: "/wall",
    category: "guts",
    image: "/lobby/wall.svg",
    banner: "/lobby/banners/wall.svg",
  },
  {
    id: "incinerator",
    title: "INCINERATOR",
    subtitle: "burn tokens. feel gud",
    path: "/incinerator",
    category: "play",
    image: "/lobby/incinerator.svg",
    banner: "/lobby/banners/incinerator.svg",
  },

  // Create
  // Gallery sunset — kept in nav for transparency, locked to read-only.
  {
    id: "gallery",
    title: "GALLERY",
    subtitle: "create and collect",
    path: "/gallery",
    category: "create",
    image: "/lobby/gallery.svg",
    banner: "/lobby/banners/gallery.png",
    isLocked: true,
  },
  {
    id: "mememaker",
    title: "MEME MAKER",
    subtitle: "shitpost for profit",
    path: "/mememaker",
    category: "create",
    image: "/lobby/mememaker.svg",
    isLocked: false,
    banner: "/lobby/banners/mememaker.png",
  },
];

// Earn apps (adds live APY where available)
export const getGameApps = (vaultApy?: string, lockApy?: string): GameApp[] => {
  const earnApps: GameApp[] = [
    {
      id: "vault",
      title: "VAULT",
      subtitle: "compound till moon",
      path: "/vault",
      image: "/lobby/vault.svg",
      category: "earn",
      banner: "/lobby/banners/vault.png",
      apy: vaultApy,
    },
    {
      id: "lock",
      title: "LOCK",
      subtitle: "diamond paws only",
      path: "/lock",
      image: "/lobby/lock.svg",
      category: "earn",
      banner: "/lobby/banners/lock.png",
      apy: lockApy,
    },
  ];

  return [...STATIC_APPS, ...earnApps];
};

export const getAppsByCategory = (apps: GameApp[], category: GameApp["category"]) =>
  apps.filter((app) => app.category === category);

export const getCategorizedApps = (apps: GameApp[]) => ({
  play: getAppsByCategory(apps, "play"),
  earn: getAppsByCategory(apps, "earn"),
  buy: getAppsByCategory(apps, "buy"),
  guts: getAppsByCategory(apps, "guts"),
  create: getAppsByCategory(apps, "create"),
});

// Optional category → bear image mapping for Navbar UI
export const NAV_BEAR_IMAGES: Record<Exclude<GameApp["category"], "buy">, string> = {
  play: "/poku/play.png",
  earn: "/poku/earn.png",
  guts: "/poku/guts.png",
  create: "/poku/create.png",
};

// App-specific character images for Navbar UI
export const APP_CHARACTER_IMAGES: Record<string, string> = {
  vault: "/poku/vault.png",
  lock: "/poku/lock.png",
  wall: "/poku/trump.png",
  incinerator: "/poku/incinerator.png",
  tetris: "/poku/play.png",
  gallery: "/poku/gallery.png",
  mememaker: "/poku/create.png",
};
